"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var MasterContext_1 = __importDefault(require("../../contexts/MasterContext"));
var ButtonCustom_1 = __importDefault(require("../ButtonCustom"));
var ButtonDelete_1 = __importDefault(require("../ButtonDelete"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Permission_1 = __importDefault(require("../Permission"));
var CrudDetail = function (props) {
    var masterItems = props.masterItems, fullItems = props.fullItems, getItem = props.getItem, infinity = props.infinity, onUpdate = props.onUpdate, onDelete = props.onDelete, onDisabled = props.onDisabled, titleExtractor = props.titleExtractor, idExtractor = props.idExtractor, valueActiveExtractor = props.valueActiveExtractor, deletePermissions = props.deletePermissions, disablePermissions = props.disablePermissions, selectedId = props.selectedId, children = props.children, extraButtons = props.extraButtons;
    var _a = react_1.useState(undefined), item = _a[0], setItem = _a[1];
    var _b = react_1.useState(fullItems), masterFullItems = _b[0], setMasterFullItems = _b[1];
    react_1.useEffect(function () {
        if (masterFullItems) {
            if (selectedId) {
                var selectedItem = masterFullItems.find(function (masterItem) {
                    var masterId = idExtractor ? idExtractor(masterItem).toString() : masterItem.id.toString();
                    return masterId === selectedId.toString();
                });
                var getItemPromise = getItem && selectedItem ? getItem(selectedItem) : Promise.resolve(selectedItem);
                getItemPromise.then(function (resp) {
                    setItem(resp);
                });
            }
        }
        else if (selectedId) {
            var selectedItem = masterItems.find(function (masterItem) {
                var masterId = idExtractor ? idExtractor(masterItem).toString() : masterItem.id.toString();
                return masterId === selectedId.toString();
            });
            var getItemPromise = getItem && selectedItem ? getItem(selectedItem) : Promise.resolve(selectedItem);
            getItemPromise.then(function (resp) {
                setItem(resp);
            });
        }
    }, [getItem, selectedId, masterFullItems]);
    react_1.useEffect(function () {
        setMasterFullItems(fullItems);
    }, [fullItems]);
    var DetailToolbar = function () {
        if (!item)
            return react_1.default.createElement(react_1.default.Fragment, null);
        var idItem = idExtractor ? idExtractor(item) : item.id;
        var itemActive = valueActiveExtractor ? valueActiveExtractor(item) : item.active;
        if (onDisabled) {
            return (react_1.default.createElement(Permission_1.default, { viewPermission: disablePermissions },
                react_1.default.createElement(ButtonCustom_1.default, { iconname: "science-minus", name: itemActive ? 'ui.commons.disable' : 'ui.commons.enable', onClick: function () { return onDisabled(idItem); } })));
        }
        if (onDelete) {
            return (react_1.default.createElement(Permission_1.default, { viewPermission: deletePermissions },
                react_1.default.createElement(ButtonDelete_1.default, { onClick: function () { return onDelete(idItem); } })));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    var crudState = react_1.useMemo(function () { return ({
        selectedItem: item,
        isCreate: false,
        isUpdate: true,
    }); }, [item]);
    var masterState = react_1.useMemo(function () { return ({
        selectedItem: item,
        handleSubmit: function (value) {
            if (onUpdate)
                onUpdate(value);
        },
    }); }, [item, onUpdate]);
    var masterTitle = react_1.useMemo(function () {
        return item ? react_1.default.createElement(FormatText_1.default, { id: titleExtractor(item), uppercase: true }) : '';
    }, [titleExtractor, item]);
    return (react_1.default.createElement(MasterContext_1.default.Provider, { value: masterState },
        react_1.default.createElement(contexts_1.CrudContext.Provider, { value: crudState },
            react_1.default.createElement(antd_1.Card, { className: "ant-app-details-area", title: masterTitle, extra: extraButtons && item ? extraButtons(item) : react_1.default.createElement(DetailToolbar, null) }, children))));
};
exports.default = CrudDetail;
